import { createSlice } from '@reduxjs/toolkit';
import { createUsers, findUser } from './api';
import { initialState } from './api/interfaces';

const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setLimit: (state, action) => {
            state.limit = action.payload.limit;
            state.status = 'idle';
        },
        setSkip: (state, action) => {
            state.skip = action.payload.skip;
            state.status = 'idle';
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload.currentPage;
        },
        removeUserById: (state, action) => {
            state.data = state.data.filter((user) => user.id !== action.payload.id);
        },
        setStatus: (state, action) => {
            state.status = action.payload.status;
        },
        reset: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(findUser.pending, (state) => {
            state.isLoading = true;
            state.status = 'pending';
        });
        builder.addCase(findUser.fulfilled, (state, action) => {
            state.data = action.payload.data;
            state.totalRecords = action.payload.total;
            state.isError = false;
            state.isSuccess = true;
            state.isLoading = false;
            state.status = 'succeeded';
        });
        builder.addCase(findUser.rejected, (state, _) => {
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
            state.status = 'failed';
        });
        builder.addCase(createUsers.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(createUsers.fulfilled, (state, _) => {
            state.isError = false;
            state.isSuccess = true;
            state.isLoading = false;
        });
        builder.addCase(createUsers.rejected, (state) => {
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
        });
        // builder.addCase(updateUserProfile.pending, (state) => {
        //     state.isLoading = true;
        // });
        // builder.addCase(updateUserProfile.fulfilled, (state, action) => {
        //     state.data = state.data.map((user) => (user.id === action.payload.id ? action.payload : user));
        //     state.isError = false;
        //     state.isSuccess = true;
        //     state.isLoading = false;
        // });
        // builder.addCase(updateUserProfile.rejected, (state) => {
        //     state.isLoading = false;
        //     state.isError = true;
        //     state.isSuccess = false;
        // });
    },
});

export const { setLimit, setSkip, setCurrentPage, removeUserById, reset, setStatus } = usersSlice.actions;
export default usersSlice.reducer;